import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginPage } from '@/pages/auth/ui/LoginPage';
import { tokenManager } from '@/shared/lib/storage';

/**
 * ログインルート定義
 *
 * App層の責務:
 * - URLパス `/login` を LoginPage にマッピング
 * - すでに認証済みの場合は `/` にリダイレクト
 * - TanStack Router のファイルベースルーティング
 * - 検索パラメータ（redirect, auth_error）の型定義
 */

// 検索パラメータのスキーマ定義
const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  auth_error: z.enum(['session_expired']).optional(),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: () => {
    // すでに認証済みの場合は /projects にリダイレクト
    if (tokenManager.isAuthenticated()) {
      throw redirect({
        to: '/projects',
      });
    }
  },
  component: LoginPage,
});
